import React, { Fragment, useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { useParams, useNavigate } from 'react-router-dom';
import { connect } from 'react-redux';
import Spinner from '../layout/Spinner';
import { getCotationById, deleteCotation } from '../../actions/cotation';
import Moment from 'react-moment';
import moment from 'moment';
import { MdDelete } from 'react-icons/md';
import { IoMdArrowBack } from 'react-icons/io';
import { useTranslation } from 'react-i18next';
import { AiOutlineEdit } from 'react-icons/ai';

const CotationDetail = ({
  getCotationById,
  deleteCotation,
  cotation: { cotation, loading },
  auth
}) => {
  const { t } = useTranslation();

  const navigate = useNavigate();
  const [action, setaction] = useState(false);
  const { id } = useParams();

  useEffect(() => {
    getCotationById(id);
  }, [getCotationById, id]);

  const DeleteCode = () => {
    setaction(true);
    deleteCotation(id);
    setTimeout(() => {
      navigate('/recherchecotations');
    }, 1000);
  };

  const identityList = [
    'manufacturer',
    'model',
    'generation',
    'version',
    'description',
    'serialnumber',
    'creatorUser',
    'generationDate'
  ];

  const manufacturerList = [
    'cote_const_LP',
    'cote_const_HB',
    'cote_const_LC',
    'cote_const_LA',
    'cote_const_D',
    'cote_const_RR',
    'cote_const_HA',
    'cote_const_HC',
    'cote_const_GS',
    'cote_const_V',
    'cote_const_LH'
  ];

  const identityFields = cotation
    ? Object.keys(cotation)
        .filter((field) => identityList.includes(field))
        // .filter((field) => field !== 'description')
        .map(
          (key, index) =>
            key !== '_id' &&
            key !== '__v' &&
            (key === 'creatorUser' ? (
              <div key={index} className="row ">
                <div className="lead col-md-4  cgu-title">
                  <strong>{key}:</strong>{' '}
                </div>
                <div
                  key={index}
                  className="col-md-8 lead text-ascorel cgu-title"
                >
                  {cotation[key].name}
                </div>
              </div>
            ) : (
              <div key={index} className="row ">
                <div className="lead col-md-4  cgu-title">
                  <strong>{key}:</strong>
                </div>
                <div
                  key={index}
                  className="lead col-md-8 text-ascorel cgu-title"
                >
                  {cotation[key]}
                </div>
              </div>
            ))
        )
    : null;

  const measureFields = cotation
    ? Object.keys(cotation)
        .filter((field) => !identityList.includes(field))
        .filter((field) => !manufacturerList.includes(field))
        .map(
          (key, index) =>
            key !== '_id' &&
            key !== '__v' && (
              <div key={index} className="col-md-6 row">
                {cotation[key] ? (
                  <div className="col-md-8 lead">
                    <strong>{key}:</strong>
                  </div>
                ) : (
                  <div className="col-md-8 lead text-danger cgu-title">
                    <strong>{key}:</strong>
                  </div>
                )}

                <div className="col-md-4 lead text-ascorel">
                  {cotation[key]}
                </div>
              </div>
            )
        )
    : null;

  const manufacturerFields = cotation
    ? Object.keys(cotation)
        .filter((field) => manufacturerList.includes(field))
        .map(
          (key, index) =>
            key !== '_id' &&
            key !== '__v' && (
              <div key={index} className="col-md-6 row">
                <div className="col-md-8 lead">
                  <strong>{key}:</strong>
                </div>
                <div className="col-md-4 lead text-ascorel">
                  {cotation[key]}
                </div>
              </div>
            )
        )
    : null;

  return (
    <section className="container">
      <Fragment>
        {cotation === null || loading || action ? (
          <Spinner />
        ) : (
          <Fragment>
            <div className="parent-flex">
              <div className="col">
                <button
                  className="btn btn-dark btn-lg"
                  onClick={() => navigate(-1)}
                >
                  <IoMdArrowBack
                    color="white"
                    style={{
                      marginRight: '0.2rem',
                      marginBottom: '0.2rem'
                    }}
                  />{' '}
                  {t('back_to_list')}
                </button>
              </div>
              {auth.isAuthenticated &&
                auth.loading === false &&
                auth.user.rights === 'admin' && (
                  <div className="parent-flex">
                    <div className="col">
                      <button
                        className="btn btn-ascorel btn-lg"
                        onClick={() => navigate(`/edit-cotation/${id}`)}
                        style={{ whiteSpace: 'nowrap' }}
                      >
                        <AiOutlineEdit
                          style={{
                            marginRight: '0.2rem',
                            marginBottom: '0.2rem'
                          }}
                        />{' '}
                        {t('update')}
                      </button>
                    </div>
                    <div className="col">
                      <button
                        className="btn btn-danger btn-lg"
                        onClick={() => DeleteCode()}
                        style={{ whiteSpace: 'nowrap' }}
                      >
                        <MdDelete
                          style={{
                            marginRight: '0.2rem',
                            marginBottom: '0.2rem'
                          }}
                        />{' '}
                        {t('delete')}
                      </button>
                    </div>
                  </div>
                )}
            </div>
            <div>
              <h2
                className="p-3 mb-1 bg-ascorel text-white text-center"
                style={{ marginTop: 10 }}
              >
                <span>
                  {t('titre_detail_cotation')} : {cotation.manufacturer} -{' '}
                  {cotation.model}
                  {cotation.version ? ` - ${cotation.version}` : ''}
                  {cotation.generation ? ` - ${cotation.generation}` : ''}
                </span>
              </h2>
            </div>
            <div style={{ marginBottom: 20, marginTop: 20 }} className="row ">
              {identityFields}
            </div>
            <h3 style={{ marginTop: 30 }}>Mesures pesage (en millimètres)</h3>
            <div className="row">{measureFields}</div>
            <h3 style={{ marginTop: 30 }}>
              Mesures constructeur (en millimètres)
            </h3>
            <div className="row">{manufacturerFields}</div>
          </Fragment>
        )}
      </Fragment>
    </section>
  );
};

CotationDetail.propTypes = {
  getCotationById: PropTypes.func.isRequired,
  deleteCotation: PropTypes.func.isRequired,
  cotation: PropTypes.object.isRequired,
  auth: PropTypes.object.isRequired
};

const mapStateToProps = (state) => ({
  cotation: state.cotation,
  auth: state.auth
});

export default connect(mapStateToProps, {
  getCotationById,
  deleteCotation
})(CotationDetail);
